import { Button, Text } from '@sendible/design-system';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { Actions, Container, MinimiseButton } from './index.styles';
import { useBackgroundUploaderContext } from '../../context';

export const Header = () => {
  const { cancelAllUploads, isMinimised, setIsMinimised, closeUploader, uploadingMediasAmount, uploadedMediasAmount, uploadingFilesLength } =
    useBackgroundUploaderContext();
  const { t } = useTranslation(['common_terms', 'media_library']);

  const isUploading = !!uploadingMediasAmount;

  const uploadingTranslation = (): string => {
    if (uploadingMediasAmount > 1) return 'uploading_items';
    if (uploadingMediasAmount === 1) return 'uploading_item';
    if (uploadingMediasAmount === 0 && uploadedMediasAmount > 1) return 'uploaded_items';
    if (uploadingMediasAmount === 0 && uploadedMediasAmount === 1) return 'uploaded_item';

    return '';
  };

  return (
    <Container>
      <Actions>
        <Button
          data-testid="close-backgrounduploader-button"
          onClick={() => {
            closeUploader();
          }}
          customClass="close-button"
          isLoading={isUploading}
          disabled={isUploading}
          size={14}
          icon="close"
        />
        <MinimiseButton
          data-testid="minimise-backgrounduploader-button"
          rotateIconDegrees={isMinimised ? 180 : 0}
          onClick={() => {
            setIsMinimised(!isMinimised);
          }}
          size={14}
          icon="minimise_alt_reverse"
        />
      </Actions>
      <Text variation="body_12">
        {useMemo(
          () =>
            t(uploadingTranslation(), {
              ns: 'media_library',
              current: isUploading ? uploadingMediasAmount : uploadedMediasAmount,
              total: uploadingFilesLength,
            }),
          [uploadingMediasAmount, uploadedMediasAmount]
        )}
      </Text>
      {isUploading && (
        <Button
          data-testid="cancel-all-uploads"
          onClick={() => {
            cancelAllUploads();
          }}
          label={t('cancel_all', { ns: 'common_terms' }) as string}
          appearance="primary"
          size={12}
        />
      )}
    </Container>
  );
};
